export default __webpack_public_path__ + "static/media/XML.a791522b.svg";